import { pushRoute } from '../../lib/router.js';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Col, Grid, Row } from 'react-bootstrap';

import { mapFinalFormErrors } from '../../lib/utils.js';
import { retrieveProject, selectProject } from '../../modules/projects.js';
import SubHeader from '../../components/SubHeader.jsx';
import ChangeImpactHeader from '../../components/headers/PageHeaders/Project/ChangeImpactHeader.jsx';
import ChangeImpactDataImportForm from '../../components/projects/ChangeImpact/ChangeImpactDataImportForm.jsx';
import { importChangeImpactData } from '../../modules/changeImpacts.js';
import { useFetchFile } from '../../hooks/useFetchFile.js';
import ImportDataProgressContainer from '../ImportDataProgressContainer.jsx';
import CiImportDataError from '../../components/projects/ChangeImpact/CiImportDataError.jsx';

const mapErrors = mapFinalFormErrors('Failed to save project');

const mapStateToProps = (state, ownProps) =>
  createSelector(selectProject(ownProps.projectId), (project) => ({
    project,
    apiUrl: state.config.apiUrl,
  }))(state);

const mapDispatchToProps = {
  retrieveProject,
  importChangeImpactData,
};

const CIDataImportFormContainer = (props) => {
  const {
    projectId,
    project,
    retrieveProject,
    importChangeImpactData,
    apiUrl,
  } = props;
  const [replaceMethod, setReplaceMethod] = useState('add');
  const { loading, downloadBlob } = useFetchFile();

  const formRef = useRef(null);

  const onSubmit = () => {
    const formData = new FormData(formRef.current);
    const composedFormData = new FormData();

    composedFormData.append('csv_file', formData.get('csv_file'));
    composedFormData.append('merge', replaceMethod === 'add');

    return importChangeImpactData(projectId, composedFormData)
      .then(() => {
        retrieveProject(projectId).then(() =>
          pushRoute('projects/change-impacts', { projectId })
        );
      })
      .catch(mapErrors);
  };

  const onDownloadErrorsCsv = () => {
    downloadBlob(
      apiUrl,
      `projects/${projectId}/change_impacts/bulk_upload/errors_csv`,
      null,
      'errors-errors-import-data CSV',
      'csv'
    );
  };

  useEffect(() => {
    retrieveProject(projectId);
  }, []);

  return (
    <div className="relative">
      <ImportDataProgressContainer
        projectId={projectId}
        status={project?.processingChangeImpactUpload}
      />
      <ChangeImpactHeader project={project} />
      <SubHeader flexJustify small>
        <h2>Data Import</h2>
      </SubHeader>
      <CiImportDataError project={project} />
      <Grid>
        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Form
                    formRef={formRef}
                    projectId={projectId}
                    replaceMethod={replaceMethod}
                    setReplaceMethod={setReplaceMethod}
                    onSubmit={onSubmit}
                    component={ChangeImpactDataImportForm}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CIDataImportFormContainer);

CIDataImportFormContainer.propTypes = {
  projectId: PropTypes.number,
};
